import "./country_tooltip.css"
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import {useTranslation} from "react-i18next";

function TooltipComponent() {

    const {t} = useTranslation()

    return (
        <>
            <OverlayTrigger
                placement='bottom'
                overlay={
                    <Tooltip id={`tooltip-bottom`}>
                        {t('tooltip.country_tooltip')}
                    </Tooltip>
                }
            >
                <div className="hover-text">
                    <span>{t('tooltip.country_tooltip_message')}</span>
                </div>
            </OverlayTrigger>
        </>
    );
}

export default TooltipComponent;